<template>
  <Box class="easy-to-use__container">
    <Box class="easy-to-use__content">
      <Box class="easy-to-use__text">
        <Box mb="6" is-flex flex-direction="column" gap="1">
          <Heading size="h6" color="orange" letter-spacing="4" is-uppercase>{{ $t('pages.ssr_landing.easy_to_use.subtitle') }}</Heading>
          <Heading class="easy-to-use__title" color="purple-pink">{{ $t('pages.ssr_landing.easy_to_use.title') }}</Heading>
        </Box>
        <CustomText size="large">{{ $t('pages.ssr_landing.easy_to_use.description') }}</CustomText>
      </Box>
      <Box class="easy-to-use__img">
        <img src="/images/landing/easy-to-use.png" srcset="/images/landing/easy-to-use@2x.png 2x">
      </Box>
    </Box>
  </Box>
</template>

<script>
import Box from '@/components/common/Box/Box'
import Heading from '@/components/common/Heading/Heading'
import CustomText from '@/components/common/CustomText/CustomText'

export default {
  components: {
    Box,
    Heading,
    CustomText
  }
}
</script>

<style lang="scss" scoped>
.easy-to-use {
  &__container {
    padding: 0 $gap;
  }

  &__content {
    display: flex;
    flex-direction: row;
    gap: $gap * 2;
    max-width: 1200px;
    margin: 0 auto;

    @include display-less(tablet) {
      flex-direction: column;
      gap: 0;
    }
  }

  &__title {
    @include display-less(tablet) {
     font-size: 32px;
     line-height: 120%;
    }
  }

  &__img {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    flex: 1 1;
  }

  &__text {
    flex: 1 1;
    padding: $gap * 3.5 0;
    margin: auto 0;
  }
}
</style>
